import { supabase } from './services/supabase';

const VAPID_PUBLIC_KEY = 'BAGnsIpwDeoaKffV-I158I21wsrQvrFOQ41WALS555aPUGXT-yzF3nshoc5NHupBH_kE__-F3o_u0AdtzSCNLT0';

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  try {
    // Register (or re-use) the service worker. The query-string cache-bust
    // is enough to force a fresh fetch — no need to unregister first.
    // Unregistering on every load was causing a controllerchange → reload
    // → unregister → register → controllerchange → reload infinite loop.
    const reg = await navigator.serviceWorker.register('/sw.js?v=20', { scope: '/' });
    console.log('[PWA] Service worker registered');

    // Only reload when a *new* (different) SW takes over — not on the
    // initial registration that we just triggered ourselves.
    let hadPreviousController = !!navigator.serviceWorker.controller;

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      // If there was already a controller before we registered, a new SW
      // just took over → reload so the user gets the fresh bundle.
      // If there was NO previous controller (first visit / hard refresh),
      // the new registration itself fires controllerchange — skip the
      // reload to avoid an infinite loop.
      if (hadPreviousController) {
        window.location.reload();
      }
    });

    reg.addEventListener('updatefound', () => {
      const newWorker = reg.installing;
      if (!newWorker) return;
      newWorker.addEventListener('statechange', () => {
        if (newWorker.state === 'activated') {
          console.log('[PWA] New version activated');
        }
      });
    });

    return reg;
  } catch (err) {
    console.error('[PWA] SW registration failed:', err);
  }
}

export async function subscribeToPush(talentId: string) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.log('[PWA] Push permission denied');
      return;
    }

    const reg = await navigator.serviceWorker.ready;
    let subscription = await reg.pushManager.getSubscription();

    if (!subscription) {
      subscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
      });
      console.log('[PWA] New push subscription created');
    }

    const subJSON = subscription.toJSON();
    // Ownership-checked: the table is closed to direct writes.
    const { error } = await supabase.rpc('register_push_subscription', {
      p_talent_id: talentId,
      p_endpoint: subJSON.endpoint,
      p_p256dh: subJSON.keys?.p256dh,
      p_auth: subJSON.keys?.auth,
      p_user_agent: navigator.userAgent,
    });
    if (error) throw error;

    console.log('[PWA] Push subscription saved');
  } catch (err) {
    console.error('[PWA] Push subscription error:', err);
  }
}
